/* Native Shopify/Evey variant IDs and product-form submission remain in use. */
if (!customElements.get('azul-ticket-phases')) {
  customElements.define('azul-ticket-phases', class extends HTMLElement {
    connectedCallback() {
      this.quantity = this.querySelector('[data-ticket-quantity]');
      this.feedback = this.querySelector('[data-ticket-feedback]');
      this.form = this.querySelector('product-form form');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelectorAll('[data-ticket-adjust]').forEach(button => {
        button.addEventListener('click', () => {
          if (!this.quantity || this.dataset.saleOpen !== 'true') return;
          if (button.dataset.ticketAdjust === '1') this.quantity.stepUp();
          else this.quantity.stepDown();
          this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }, options);
      });
      this.quantity?.addEventListener('input', () => this.updateQuantity(), options);
      this.quantity?.addEventListener('change', () => this.updateQuantity(), options);
      this.form?.addEventListener('submit', event => this.checkBeforeSubmit(event), { ...options, capture: true });
      this.updateQuantity();
    }

    disconnectedCallback() { this.abort?.abort(); }

    updateQuantity() {
      if (!this.quantity) return;
      const minimum = Number(this.quantity.min) || 1;
      const maximum = this.quantity.max === '' ? Infinity : Number(this.quantity.max);
      const value = Number(this.quantity.value);
      this.querySelector('[data-ticket-adjust="-1"]').disabled = this.dataset.saleOpen !== 'true' || value <= minimum;
      this.querySelector('[data-ticket-adjust="1"]').disabled = this.dataset.saleOpen !== 'true' || value >= maximum;
    }

    syncPriceRow(html) {
      const current = this.closest('product-info')?.querySelector('[data-ticket-phase-price]');
      if (!current) return;
      const updated = html.getElementById(current.id);
      if (updated) current.innerHTML = updated.innerHTML;
    }

    showFeedback(message) {
      if (!this.feedback) return;
      this.feedback.textContent = message;
      this.feedback.hidden = false;
    }

    async checkBeforeSubmit(event) {
      if (this.allowCheckedSubmit) {
        this.allowCheckedSubmit = false;
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.checking || this.dataset.saleOpen !== 'true' || !this.quantity) return;
      if (!this.quantity.reportValidity()) return;
      const button = this.form.querySelector('[type="submit"]');
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      this.checking = true;
      this.setAttribute('aria-busy', 'true');
      button.disabled = true;
      try {
        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('_azul_phase_check', String(Date.now()));
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' }, signal: this.abort.signal });
        if (!response.ok) throw new Error('Ticket availability could not be checked');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = Array.from(html.querySelectorAll('azul-ticket-phases')).find(widget => widget.dataset.productId === this.dataset.productId);
        if (!fresh) throw new Error('Ticket configuration could not be checked');
        if (!this.isConnected) return;
        const changed = fresh.dataset.activeVariant !== this.dataset.activeVariant || fresh.dataset.unitPrice !== this.dataset.unitPrice || fresh.dataset.saleOpen !== this.dataset.saleOpen;
        if (changed) {
          this.syncPriceRow(html);
          const message = fresh.querySelector('[data-ticket-feedback]');
          if (message) {
            message.textContent = 'Die Ticketphase oder Verfügbarkeit hat sich geändert. Bitte prüfe die aktuelle Auswahl.';
            message.hidden = false;
          }
          this.replaceWith(document.importNode(fresh, true));
          return;
        }
        const freshQuantity = fresh.querySelector('[data-ticket-quantity]');
        if (!freshQuantity) throw new Error('Ticket quantity could not be checked');
        for (const attribute of ['min', 'max', 'step']) {
          const value = freshQuantity.getAttribute(attribute);
          if (value === null) this.quantity.removeAttribute(attribute);
          else this.quantity.setAttribute(attribute, value);
        }
        this.updateQuantity();
        if (!this.quantity.reportValidity()) {
          this.showFeedback('Bitte passe die Ticketanzahl an die aktuelle Verfügbarkeit an.');
          return;
        }
        const variantInput = this.form.querySelector('[name="id"]');
        if (!variantInput) throw new Error('Ticket variant is missing');
        variantInput.value = this.dataset.activeVariant;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        button.disabled = false;
        this.allowCheckedSubmit = true;
        this.form.requestSubmit(button);
        this.allowCheckedSubmit = false;
      } catch (error) {
        if (error.name !== 'AbortError') this.showFeedback('Die Ticketverfügbarkeit konnte gerade nicht geprüft werden. Bitte versuche es erneut.');
      } finally {
        this.checking = false;
        this.removeAttribute('aria-busy');
        if (this.isConnected) button.disabled = this.dataset.saleOpen !== 'true';
      }
    }
  });
}
